import { authedFetch } from '../authedFetch';

// POST /api/me/payment-plans — start a plan for the given open invoices,
// split evenly over `installments` monthly Stripe charges.
export const createPaymentPlan = async (invoiceIds, installments) => {
  const res = await authedFetch('/me/payment-plans', {
    method: 'POST',
    body: JSON.stringify({ invoiceIds, installments }),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.msg || `Could not start payment plan (${res.status})`);
  return json;
};

// GET /api/me/payment-plans — the signed-in member's own plans.
export const getPaymentPlans = async () => {
  const res = await authedFetch('/me/payment-plans');
  const json = await res.json();
  if (!res.ok) throw new Error(json.msg || `Could not load payment plans (${res.status})`);
  return json.plans || [];
};

// POST /api/me/payment-plans/:id/cancel — member-initiated cancellation.
export const cancelPaymentPlan = async (planId) => {
  const res = await authedFetch(`/me/payment-plans/${planId}/cancel`, {
    method: 'POST',
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json.msg || `Could not cancel payment plan (${res.status})`);
  return json;
};
